// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { resolveOrganizationScope } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/explore/ai-catalog/agents`
 * - Path helper: `explore_ai_catalog_agents_path`
 * - URL helper: `explore_ai_catalog_agents_url`
 * - controller#action: `explore/ai_catalog#index`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const exploreAiCatalogAgentsPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreAiCatalogAgentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"ai-catalog"],[2,[7,"/"],[6,"agents"]]]]]]]]]]);
  const _exploreAiCatalogAgentsPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"ai-catalog"],[2,[7,"/"],[6,"agents"]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationExploreAiCatalogAgentsPath(organizationPath, ...routeArgs);
  }

  return _exploreAiCatalogAgentsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/ai-catalog/agents/:id`
 * - Path helper: `explore_ai_catalog_agent_path`
 * - URL helper: `explore_ai_catalog_agent_url`
 * - controller#action: `explore/ai_catalog#index`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const exploreAiCatalogAgentPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreAiCatalogAgentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"ai-catalog"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);
  const _exploreAiCatalogAgentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"ai-catalog"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[3,"id"]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationExploreAiCatalogAgentPath(organizationPath, ...routeArgs);
  }

  return _exploreAiCatalogAgentPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/ai-catalog/flows`
 * - Path helper: `explore_ai_catalog_flows_path`
 * - URL helper: `explore_ai_catalog_flows_url`
 * - controller#action: `explore/ai_catalog#index`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const exploreAiCatalogFlowsPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreAiCatalogFlowsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"ai-catalog"],[2,[7,"/"],[6,"flows"]]]]]]]]]]);
  const _exploreAiCatalogFlowsPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"ai-catalog"],[2,[7,"/"],[6,"flows"]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationExploreAiCatalogFlowsPath(organizationPath, ...routeArgs);
  }

  return _exploreAiCatalogFlowsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/ai-catalog/flows/:id`
 * - Path helper: `explore_ai_catalog_flow_path`
 * - URL helper: `explore_ai_catalog_flow_url`
 * - controller#action: `explore/ai_catalog#index`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const exploreAiCatalogFlowPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreAiCatalogFlowPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"ai-catalog"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);
  const _exploreAiCatalogFlowPath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"ai-catalog"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[3,"id"]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationExploreAiCatalogFlowPath(organizationPath, ...routeArgs);
  }

  return _exploreAiCatalogFlowPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/ai-catalog(/*vueroute)`
 * - Path helper: `explore_ai_catalog_path`
 * - URL helper: `explore_ai_catalog_url`
 * - controller#action: `explore/ai_catalog#index`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const exploreAiCatalogPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreAiCatalogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"ai-catalog"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]);
  const _exploreAiCatalogPath = /*#__PURE__*/ __jsr.r({"vueroute":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"ai-catalog"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationExploreAiCatalogPath(organizationPath, ...routeArgs);
  }

  return _exploreAiCatalogPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/analytics_dashboards(/*vueroute)(.:format)`
 * - Path helper: `explore_analytics_dashboards_path`
 * - URL helper: `explore_analytics_dashboards_url`
 * - controller#action: `explore/analytics_dashboards#index`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const exploreAnalyticsDashboardsPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreAnalyticsDashboardsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"analytics_dashboards"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);
  const _exploreAnalyticsDashboardsPath = /*#__PURE__*/ __jsr.r({"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"analytics_dashboards"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationExploreAnalyticsDashboardsPath(organizationPath, ...routeArgs);
  }

  return _exploreAnalyticsDashboardsPath(...routeArgs);
};

